import React from 'react';
import { string } from 'prop-types';
import { interpolator } from '@fiverr-private/futile';
import { Section } from '@fiverr-private/fit';
import FiverrProLogo from '@fiverr-private/fit/icons/logos/fiverr_pro_logo';
import { ResponsivePicture } from '../../common/responsive_picture';
import { getCategoryPicture } from './helper';

import './index.scss';

const WHITE_FILL = '#FFF';

export const CategoryBanner = ({
    categoryName,
    banner,
    title
}) => {
    const { src, picture } = getCategoryPicture(banner);
    // eslint-disable-next-line no-useless-escape
    const interpolate = interpolator(/\%{([^{}]*)}/gm);
    const interpolatedTitle = interpolate(title, {
        subcat_name: categoryName
    });

    return (
        <figure className="category-banner">
            <Section className="figcaption">
                <div className="fiverr-pro-logo">
                    <FiverrProLogo primaryColor={WHITE_FILL}/>
                </div>
                <h1 dangerouslySetInnerHTML={{ __html: interpolatedTitle }}/>
            </Section>
            <div className="background-container">
                <ResponsivePicture src={src} alt={categoryName} picture={picture}/>
            </div>
        </figure>
    );
};

CategoryBanner.propTypes = {
    categoryName: string.isRequired,
    banner: string.isRequired,
    title: string.isRequired
};
